//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.5'.
//
package graphql

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import graphql.adapter.GetTradeNewsByCategoryQuery_ResponseAdapter
import graphql.adapter.GetTradeNewsByCategoryQuery_VariablesAdapter
import graphql.selections.GetTradeNewsByCategoryQuerySelections
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public data class GetTradeNewsByCategoryQuery(
  public val category: String,
) : Query<GetTradeNewsByCategoryQuery.Data> {
  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    GetTradeNewsByCategoryQuery_VariablesAdapter.toJson(writer, customScalarAdapters, this)
  }

  public override fun adapter(): Adapter<Data> =
      GetTradeNewsByCategoryQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = graphql.type.Query.type
  )
  .selections(selections = GetTradeNewsByCategoryQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(GetTradeNewsByCategoryQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val tradeNewsByCategory: List<TradeNewsByCategory>,
  ) : Query.Data

  public data class TradeNewsByCategory(
    /**
     * ニュースの一意識別子
     */
    public val id: String,
    /**
     * ニュースのタイトル
     */
    public val title: String,
    /**
     * ニュースの説明文
     */
    public val description: String?,
    /**
     * ニュースへのリンク
     */
    public val link: String,
    /**
     * ニュースソース（ESPN、RealGMなど）
     */
    public val source: String,
    /**
     * 公開日時
     */
    public val publishedAt: String,
    /**
     * カテゴリー（Trade、Signing、Other）
     */
    public val category: String,
    /**
     * 日本語タイトル
     */
    public val titleJa: String?,
    /**
     * 日本語説明文
     */
    public val descriptionJa: String?,
    /**
     * 翻訳ステータス
     */
    public val translationStatus: String,
    /**
     * 翻訳日時
     */
    public val translatedAt: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "c29d8e833cb060f8c7e67e20f4a6d79d2b396f97373f95fdb26f5e1d87f47622"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query GetTradeNewsByCategory($category: String!) {
     *   tradeNewsByCategory(category: $category) {
     *     id
     *     title
     *     description
     *     link
     *     source
     *     publishedAt
     *     category
     *     titleJa
     *     descriptionJa
     *     translationStatus
     *     translatedAt
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query GetTradeNewsByCategory(${'$'}category: String!) { tradeNewsByCategory(category: ${'$'}category) { id title description link source publishedAt category titleJa descriptionJa translationStatus translatedAt } }"

    public const val OPERATION_NAME: String = "GetTradeNewsByCategory"
  }
}
